import avaliacoesRepo from './avaliacoesRepo';
import modelosRepo from './modelosRepo';
import secoesRepo from './secoesRepo';
import questoesRepo from './questoesRepo';
import resultadosRepo from './resultadosRepo';

const mockAvaliacoes = {
  avaliacoesRepo,
  modelosRepo,
  secoesRepo,
  questoesRepo,
  resultadosRepo
};

export default mockAvaliacoes;
